// i18n.js
export const translations = {
  fr: {
    help: "COMMENT POUVONS-NOUS VOUS AIDER ?",
    enterMessage: "Entrez votre message",
    placeholder: "Écrivez un message...",
    phone: "Numéro de téléphone",
    address: "entrez votre adresse",
    createdBy: "CRÉÉ PAR",
    privacy: "la Politique de confidentialité",
    terms: "les Conditions d'utilisation",
    and: "et",
    or: "ou",
    prevention: "En envoyant mes informations, j'accepte leur collecte et leur traitement selon",
    initMessage: "Salut je suis votre assistant virtuel, comment puis-je vous aider ?",
    enterAddress: "Entrez votre address",
    selectDate: "Selectionnez une date",
    selectTime: "Selectionnez une heure",
    initErrorMessage: "Une erreur inconnue est survenue.",
    contactMessage: "Vous pouvez contacter l'administrateur",
    restartConversation: "recommencer la conversation",
    ratingLabel: "Comment avez-vous trouvé cet échange?"
  },
  en: {
    help: "HOW CAN WE HELP YOU?",
    enterMessage: "Enter your message",
    phone: "Phone number",
    placeholder: "Type a message...",
    address: "enter your address",
    createdBy: "CREATED BY",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    and: "and",
    or: "or",
    prevention: "By submitting my information, I consent to its collection and processing in accordance with",
    initMessage: "Hi, I'm your virtual assistant. How can I help you?",
    enterAddress: "Enter your address",
    selectDate: "Select a date",
    selectTime: "Select a time",
    initErrorMessage: "An unknown error has occurred.",
    contactMessage: "Please contact the administrator",
    restartConversation: "restart the conversation",
    ratingLabel: "What did you think of this discussion?",
  }
};

export const t = (key, lang = "fr") => {
  return translations[lang]?.[key] || key;
};